import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn as clsx } from "../../helpers/react.js";
import { IconWrapper } from "../IconWrapper/index.js";
import { withThemeAndSize } from "../withThemeAndSize/index.js";
import '../../assets/index5.css';const actionButton = "_actionButton_17v76_1";
const standard = "_standard_17v76_33";
const active = "_active_17v76_42";
const ghost = "_ghost_17v76_51";
const destructive = "_destructive_17v76_69";
const colour = "_colour_17v76_87";
const badgeContainer = "_badgeContainer_17v76_103";
const s = {
  actionButton,
  standard,
  active,
  ghost,
  destructive,
  colour,
  badgeContainer
};
const ActionIcon = withThemeAndSize(
  forwardRef(
    ({
      className,
      disabled = false,
      icon,
      actionIconType: badgeType = "standard",
      onClick,
      badge,
      badgeContainerClassName,
      active: active2,
      ...rest
    }, ref) => {
      return /* @__PURE__ */ jsxs(
        "button",
        {
          ...rest,
          ref,
          disabled,
          className: clsx(
            s.actionButton,
            s[badgeType],
            {
              [s.active]: active2
            },
            className
          ),
          onClick,
          children: [
            /* @__PURE__ */ jsx(IconWrapper, { size: "md", children: icon }),
            badge && /* @__PURE__ */ jsx("div", { className: clsx(s.badgeContainer, badgeContainerClassName), children: badge })
          ]
        }
      );
    }
  )
);
export {
  ActionIcon
};
